const state = {
  point: 0
};

const mutations = {
  SET_POINT: (state, point) => {
    state.point = point;
  }
};

const actions = {
  setPoint({ commit }, point) {
    // console.log("SET_POINT", point);
    commit("SET_POINT", point);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
